<template>
  <span>
    <el-popover
      v-model="openPopupSocial"
      placement="bottom-end"
      width="380"
      trigger="click"
    >
      <span v-if="styleIcon == 'primary'" slot="reference">
        <el-button
          icon="el-icon-share"
          circle
          size="mini"
          class="secondary mg-l-4"
        ></el-button>
        <a class="mg-l-5 color-primary">แชร์</a>
      </span>
      <el-button
        v-if="styleIcon == 'warning'"
        slot="reference"
        icon="el-icon-share"
        circle
        size="small"
        type="warning"
      ></el-button>

      <div class="text-center pd-b-3">
        <div @click="openPopupSocial = false" class="text-right pd-x-3">
          <i class="fas fa-times color-gray-lighter cursor-pointer"></i>
        </div>

        <p>แชร์ หลักสูตร {{ courseName }}</p>
        <div class="flex-display ai-center js-center">
          <div
            v-for="item in socialList"
            :key="item.id"
            class="pd-x-4 text-center"
          >
            <ShareNetwork
              v-if="item.network != 'copyLink'"
              :network="item.network"
              :url="`${urlFront}${urlCopy}`"
              :title="message"
              :description="message"
              :quote="message"
              hashtags="AvocadoX"
            >
              <div class="flex-display flex-column ai-center">
                <div
                  class="circle-social"
                  :style="`background-color:${item.color}`"
                >
                  <i
                    v-if="item.network == 'facebook'"
                    class="fab fa-facebook-f"
                  ></i>
                  <i
                    v-if="item.network == 'twitter'"
                    class="fab fa-twitter"
                  ></i>
                  <i v-if="item.network == 'line'" class="fab fa-line"></i>
                </div>
                <span>{{ item.label }}</span>
              </div>
            </ShareNetwork>
            <div v-else class="flex-display flex-column ai-center">
              <div
                @click="copyLink"
                class="circle-social cursor-pointer"
                :style="`background-color:${item.color}`"
              >
                <i class="fas fa-link"></i>
              </div>
              <span @click="copyLink" class="cursor-pointer">{{
                item.label
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </span>
</template>

<script>
export default {
  props: {
    styleIcon: {
      type: String,
      default() {
        return "primary";
      },
    },
    courseName: {
      type: String,
      default() {
        return "";
      },
    },
    message: {
      type: String,
      default() {
        return "";
      },
    },
    urlCopy: {
      type: String,
      default() {
        return "";
      },
    },
  },
  data() {
    return {
      socialList: [
        { id: 1, network: "facebook", label: "Facebook", color: "#3A559F" },
        { id: 2, network: "twitter", label: "Twitter", color: "#1B9DEB" },
        { id: 3, network: "line", label: "Line", color: "#40C005" },
        { id: 4, network: "copyLink", label: "คัดลอกลิงค์", color: "#FFB800" },
      ],
      openPopupSocial: false,
      urlFront: process.env.VUE_APP_BASE_URL_FRONT,
      
    };
  },
  methods: {
    copyLink() {
      const el = document.createElement("textarea");
      el.value = `${this.urlFront}${this.urlCopy}`;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$message({
        showClose: true,
        message: "คัดลอกเรียบร้อย",
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
.circle-social {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.link-copy {
  position: absolute;

  z-index: -99;
}
</style>
